import React, { useState } from "react";
import {
  CancelButton,
  SubmitButton,
} from "../../../../../../Components/Utils/Buttons";
import { useFormik } from "formik";
import {FormikSelectTwoSmall,} from "../../../../../../Components/Utils/Select";
import { NuDateSmall } from "../../../../../../Components/Utils/Input";
import NewReportTable from "../../../../../../Components/Others/NewReportTable";
import UseFetchReportData from "../../../../../../Components/Hooks/useFetchReportData";
import useFetchMataData from "../../../../../../Components/Hooks/useFetchMataData";
import {
  DownloadPDF,
  DownloadXLXS,
} from "../../../../../../Components/Utils/Download";
import UseCustomerDropDownNew from "../../../../../../Components/Hooks/useCustomerSearch";

function OutgoingReport() {
  const [showFilter, setShowFilter] = useState(false);
  // const { data: RFQAssignee } = UseDropDown("/user/procurement/drop-down");
  const [filter, setFilter] = useState(false);

  const [searchClient, setSearchClient] = useState("");
  const { data: client, setDataCustomer } = UseCustomerDropDownNew(
    "/clients/drop-down",
    searchClient
  );

  const headers = [
    {
      title: "Ref.",
      width: "10%",
      field: "Ref",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Client",
      width: "10%",
      field: "ClientName",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Invoice Amount",
      width: "10%",
      field: "TotalAmount",
      textAlign: "left",
      rowAlign: "left",
      type: "amount",
    },
    {
      title: "Due Date",
      width: "10%",
      field: "PaymentDueDate",
      textAlign: "left",
      rowAlign: "left",
      type: "date",
    },
    {
      title: "Received Amount",
      width: "10%",
      field: "ReceivedAmount",
      textAlign: "left",
      rowAlign: "left",
      type: "amount",
    },
    {
      title: "Balance Amount",
      width: "10%",
      field: "BalanceAmount",
      textAlign: "left",
      rowAlign: "left",
      type: "amount",
    },
    {
      title: "Status",
      width: "10%",
      field: "Status",
      textAlign: "left",
      rowAlign: "left",
    },
  ];
  const [filterProps, setFilterProps] = useState({
    status: "",
    dateFrom:"",
    dateTo:"",
    clientId:"",
  });

  const [params, setParams] = useState({
    status: "",
    dateFrom:"",
    dateTo:"",
    clientId:"",
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value) => {
      await new Promise((resolve) => setTimeout(resolve, 300)); // give Formik time to set isSubmitting
      setParams({
        status:value?.status||"",
        dateFrom:value?.dateFrom||"",
        dateTo:value?.dateTo||"",
        clientId:value?.clientId||"",
      });
      setTimeout(() => {
        setFilter(true);
        // closeFilterDialog();
      }, 1000);
    },
  });
  const { data, getData, dataLoading, total, other } = UseFetchReportData(
    "/xlsx-report/filter-invoice-outgoing",
    params
  );

  function closeFilterDialog() {
    setShowFilter(false);
    formik.resetForm();
    setFilter(false);
    setParams({
      status: "",
      dateFrom:"",
      dateTo:"",
      clientId:"",
    });
  }

  const { value: status, getData: refstatus } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Status_Outgoing"
  );

  return (
    <>
      <div className="w-[100%] h-[calc(100vh-135px)] mt-2 bg-white rounded-lg px-3 pb-1 overflow-y-auto">
        <div className="flex gap-x-2 justify-between  w-full  py-2">
          <div className=" max-w-[300px] pr-7 ">
            <p className=" font-semibold text-xs 2xl:text-sm  ">
              Invoice Outgoing Report : {data?.length}
            </p>
          </div>
          <div className=" flex-1 ">
            <form onSubmit={formik.handleSubmit}>
              <div className=" w-full grid grid-cols-5  gap-3">
                <NuDateSmall
                  label="From "
                  placeholder="dd/mm/yyyy"
                  formik={formik}
                  name="dateFrom"
                  width="w-full"
                />
                <NuDateSmall
                  label="To "
                  placeholder="dd/mm/yyyy"
                  formik={formik}
                  name="dateTo"
                  width="w-full"
                />

                <FormikSelectTwoSmall
                  type="text"
                  label="Client "
                  placeholder="Client  "
                  Options={client}
                  formik={formik}
                  name="clientId"
                  width="w-full "
                  FixPosition={false}
                  PortalTarget={true}
                  setSearch={setSearchClient}
                />

                <FormikSelectTwoSmall
                  label="Status"
                  Options={status}
                  formik={formik}
                  placeholder="Choose"
                  name="status"
                  width="w-full "
                />
                <div className=" w-full flex justify-end ">
                  <div className=" w-full flex items-end gap-2">
                    <SubmitButton name="Apply" isLoading={formik.isSubmitting} />
                    <CancelButton
                      label="Clear"
                      handleClick={closeFilterDialog}
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className=" w-[80px] flex justify-end items-end gap-4 ">
            <DownloadPDF
              url={`/xlsx-report/export-invoice-outgoing-pdf`}
              fileName="Outgoing Report"
              params={params}
            />
            <DownloadXLXS
              url={`/xlsx-report/export-invoice-outgoing-excel`}
              fileName="Outgoing Report"
              params={params}
            />
          </div>
        </div>
        {/* <div className="w-full   items-center gap-x-3">

                <div className='flex gap-x-2 justify-between items-center w-full'>
                  <p className=" font-semibold text-xs 2xl:text-sm relative top-[-40px] ">
                  Outgoing Report : {data?.length}
                  </p>

                  <form onSubmit={formik.handleSubmit} className='flex flex-wrap'>
            <div className=' w-full flex gap-x-3'>
                              <NuDateSmall
                               label="From "
                               placeholder="dd/mm/yyyy"
                               formik={formik}
                               name="dateFrom"
                               width="w-full"
                             />
                              <NuDateSmall
                               label="To "
                               placeholder="dd/mm/yyyy"
                               formik={formik}
                               name="dateTo"
                               width="w-full"
                             />
                             

                           <FormikSelectTwoSmall
                                                        type="text"
                                                        label="Client "
                                                        placeholder="Client  "
                                                        Options={client}
                                                        formik={formik}
                                                        name="clientId"
                                                       width="w-full "
                                                        FixPosition={false}
                                                        PortalTarget={true}
                                                        
                                                        setSearch={setSearchClient}
                                                      />

  <FormikSelectTwoSmall
              label="Status"
              Options={status}
              formik={formik}
              placeholder="Choose"
              name="status"

              width="w-full "
            />

              
              
            </div>
            <div className=" w-full flex justify-end ">
                <div className=" w-full flex justify-end items-end gap-2">
                  <SubmitButton name="Apply" />
                  <CancelButton label='Clear'  handleClick={closeFilterDialog} />
                </div>
              </div>
            </form>

                 
                  
             <div className=" flex gap-4 justify-end relative top-[-40px]">
                      <DownloadPDF
                        url={`/xlsx-report/filter-invoice-outgoing`}
                        fileName="Support Tickets Report"
                        params={params}
                      />
                      <DownloadXLXS
                        url={`/xlsx-report/export-invoice-outgoing`}
                        fileName="Support Tickets Report"
                        params={params}
                      />
                    </div>
                  </div>

                   

         

        </div> */}
        <NewReportTable
          headers={headers}
          data={data}
          dataLoading={dataLoading}
        />
      </div>
    </>
  );
}

export default OutgoingReport;
